import { adminHttpClient } from '../../../commons/adminHttpClient'
import localStorage from '../../../commons/localStorage'
import { ApplicationInfo } from '../state'

export type Step2Question2Values = Pick<
  ApplicationInfo,
  'whyConsiderAlternatives' | 'whyConsiderAlternativesOther' | 'whyConsiderAlternativesOptions'
> & {
  token: string
}

const question2Api = (values: Step2Question2Values): Promise<any> => {
  const code = localStorage.getProspectSignupCode()

  return adminHttpClient.put('/IchraDecisionTool/ProspectApplication/Step2/Question2', {
    ...values,
    token: code,
  })
}

export default question2Api
